export const getNextPath = (search: string) => {
  const requestedPath = new URLSearchParams(search).get('next');
  return requestedPath?.startsWith('/') && !requestedPath.startsWith('//') ? requestedPath : '/';
};
